import { Avatar, List, ListItemAvatar, ListItemButton, ListItemText, Typography } from "@mui/material";
import { BackupTable as BackupTableIcon, WebAsset as WebAssetIcon, ViewAgenda as ViewAgendaIcon, ViewWeek as ViewWeekIcon, Window as WindowIcon } from "@mui/icons-material"

export default function LayoutModule({
  t,
  dataInstance,
  changeDataFunction
}) {

  const food_presentations = [
    {
      key: "fp_card",
      title: "Tarjeta",
      subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <WebAssetIcon />
    },
    {
      key: "fp_row",
      title: "Fila",
      subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <ViewAgendaIcon />
    },
    {
      key: "fp_grid",
      title: "Rejilla",
      subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <WindowIcon />
    },
  ]

  const drink_presentations = [
    {
      key: "dp_list",
      title: "Lista",
      subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <ViewWeekIcon />
    },
    {
      key: "dp_card",
      title: "Tarjeta",
      subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <WebAssetIcon />
    },
    {
      key: "dp_grid",
      title: "Rejilla",
      subtitle: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      icon: <WindowIcon />
    },
  ]

  const handleSelectFoodPresentation = (key) => changeDataFunction({ target: { name: "foodPresentation", value: key } })

  const handleSelectDrinkPresentation = (key) => changeDataFunction({ target: { name: "drinkPresentation", value: key } })

  return (<>
    <Typography variant="h6" sx={{ display: "flex", alignItems: "center" }}><BackupTableIcon /> &nbsp; {t('designmenu_select_option_layout')}</Typography>
    <Typography sx={{ mt: 2, mb: 2, fontWeight: "bold" }} variant="body1" component="div"> Comida </Typography>
    <List>
      {food_presentations.map((item, index) => (
        <ListItemButton
          sx={{ backgroundColor: dataInstance.foodPresentation === item.key ? "#b8b9bb" : null }}
          key={`${index}-${item.title}`}
          onClick={() => handleSelectFoodPresentation(item.key)} >
          <ListItemAvatar> <Avatar> {item.icon} </Avatar> </ListItemAvatar>
          <ListItemText primary={item.title} secondary={item.subtitle} />
        </ListItemButton>
      ))}
    </List>
    <Typography sx={{ mt: 2, mb: 2, fontWeight: "bold" }} variant="body1" component="div"> Bebida </Typography>
    <List>
      {drink_presentations.map((item, index) => (
        <ListItemButton
          sx={{ backgroundColor: dataInstance.drinkPresentation === item.key ? "#b8b9bb" : null }}
          key={`${index}-${item.title}`}
          onClick={() => handleSelectDrinkPresentation(item.key)} >
          <ListItemAvatar> <Avatar> {item.icon} </Avatar> </ListItemAvatar>
          <ListItemText primary={item.title} secondary={item.subtitle} />
        </ListItemButton>
      ))}
    </List>
  </>)
}